// export const LocalStore = {
//     isLogin: () =>{
//         let data = localStorage.getItem("data");
//         if(data != null) return true;
//         else return false;
//     },
//     doLogin: (data, next) => {
//         const {user,...restItem} = data;
//         localStorage.setItem("data", JSON.stringify(restItem));
//         localStorage.setItem('isUser', JSON.stringify({status: true, user: user}));
//         return true;
//     },
//     doLogout: () => {
//         localStorage.removeItem("data");
//         localStorage.removeItem("isUser");
//         localStorage.removeItem("userListGridState");
//         window.location.href = "/login"; // Redirect to /login page
//         return true;
//     },
//     getCurrentUserDetails: () => {
//         if(LocalStore.isLogin){
//             return JSON.parse(localStorage.getItem("data"));
//         }else{
//             window.location.href = "/login";
//             return false;
//         }
//     },
//     getLoggedUserDetails: () => {
//         if(LocalStore.isLogin){
//             console.log("User is logged in:",LocalStore.isLogin);
//             console.log("getLoggedUserDetails");
//             return JSON.parse(localStorage.getItem("isUser"))?.user;
//         }else{
//             window.location.href = "/login";
//             return false;
//         }
//     }

// }; 

export const LocalStore = {
    isLogin: () => {
        let data = localStorage.getItem("data");
        if(data != null) return true;
        else return false;
    },
    doLogin: (data, next) => {
        console.log("lksdgjssssslkdsjglkjdkl")
        const {user, ...restItem} = data;
        localStorage.setItem("data", JSON.stringify(restItem));
        localStorage.setItem('isUser', JSON.stringify({status: true, user: user}));
        // Redirect to last visited URL or default page after login
        const lastVisitedUrl = JSON.parse(localStorage.getItem("lastVisitedInfo")).lastVisitedUrl;
        const lastUserId = JSON.parse(localStorage.getItem("lastVisitedInfo")).id;
        const lastUserRole = JSON.parse(localStorage.getItem("lastVisitedInfo")).role;
        if (data.id==lastUserId && data.role==lastUserRole && lastVisitedUrl && lastVisitedUrl !== "/login") {
            console.log("last visited url:",lastVisitedUrl)
            localStorage.removeItem("lastVisitedInfo"); // Clean up
            window.location.href = lastVisitedUrl;
        } else {
            // Default redirect after login (modify as needed)
            window.location.href = "/admin";
        }
        return true;
    },
    doLogout: () => {
        const currentUrl = window.location.pathname + window.location.search;
        const loggedUserDetails =LocalStore.getCurrentUserDetails();
        // logged user id and last visited url store in local storage
        const lastLoggedDetails = {
            id:loggedUserDetails.id,
            role:loggedUserDetails.role,
            lastVisitedUrl: currentUrl
        }
        localStorage.setItem("lastVisitedInfo", JSON.stringify(lastLoggedDetails));
        
        localStorage.removeItem("data");
        localStorage.removeItem("isUser");
        localStorage.removeItem("userListGridState");
        window.location.href = "/login"; // Redirect to /login page
        return true;
    },
    getCurrentUserDetails: () => {
        if(LocalStore.isLogin()){ // Fixed: Added parentheses to call the function
            return JSON.parse(localStorage.getItem("data"));
        } else {
            window.location.href = "/login";
            return false;
        }
    },
    getLoggedUserDetails: () => {
        if(LocalStore.isLogin()){ 
            return JSON.parse(localStorage.getItem("isUser"))?.user;
        } else {
            window.location.href = "/login";
            return false;
        }
    }
};